import { Chip, ChipProps } from '@mui/material';
import { useIntl } from 'react-intl';
import { triggerMessages } from '../messages';

interface Props {
  type: string;
  size?: ChipProps['size'];
}

export function AodTriggerType({ type, size }: Props) {
  const { $t } = useIntl();
  const message = triggerMessages[type];
  const label = message ? $t(message) : type;

  return <Chip label={label} size={size} />;
}
